export const GET_IMAGE_COMMENTS_REQUEST = 'GET_IMAGE_COMMENTS_REQUEST';
export const GET_IMAGE_COMMENTS_SUCCESS = 'GET_IMAGE_COMMENTS_SUCCESS';
export const GET_IMAGE_COMMENTS_FAILED = 'GET_IMAGE_COMMENTS_FAILED';

export const ADD_MSG_TO_ONE_IMAGE_REQUEST = 'ADD_MSG_TO_ONE_IMAGE_REQUEST';
export const ADD_MSG_TO_ONE_IMAGE_SUCCESS = 'ADD_MSG_TO_ONE_IMAGE_SUCCESS';
export const ADD_MSG_TO_ONE_IMAGE_FAILED = 'ADD_MSG_TO_ONE_IMAGE_FAILED';

export const ADD_MSG_TO_ALL_IMAGES_REQUEST = 'ADD_MSG_TO_ALL_IMAGES_REQUEST';
export const ADD_MSG_TO_ALL_IMAGES_SUCCESS = 'ADD_MSG_TO_ALL_IMAGES_SUCCESS';
export const ADD_MSG_TO_ALL_IMAGES_FAILED = 'ADD_MSG_TO_ALL_IMAGES_FAILED';
